/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MotorLabData } from './MotorLabData';
import type { MotorState } from './MotorState';
import type { MotorThermalLimits } from './MotorThermalLimits';
import type { ThermalModel } from './ThermalModel';
/**
 * Create Motor From Lab Model.
 */
export type MotorLab = {
    item_type?: MotorLab.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    component_type?: MotorLab.component_type;
    lab_data: MotorLabData;
    max_speed: number;
    flow_rate?: number;
    state?: MotorState;
    thermal_model?: (ThermalModel | null);
    thermal_limits?: MotorThermalLimits;
};
export namespace MotorLab {
    export enum item_type {
        COMPONENT = 'component',
    }
    export enum component_type {
        MOTOR_LAB_MODEL = 'MotorLabModel',
    }
}

